/* Fade Index motion. Reveals, stitch lines and counters.
   Elements opt in with data-fi-reveal. Cards and stitch rules are added automatically. */
(function () {
  window.FIMotion = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tag() {
    var auto = document.querySelectorAll('.fi-card, .fi-stitch-rule, .fi-eyebrow, .fi-h2');
    for (var i = 0; i < auto.length; i++) {
      if (!auto[i].hasAttribute('data-fi-reveal')) auto[i].setAttribute('data-fi-reveal', '');
    }
  }

  function count(el) {
    var target = parseFloat(el.getAttribute('data-fi-count')) || 0;
    var pad = (el.getAttribute('data-fi-pad') || '').length;
    var suffix = el.getAttribute('data-fi-suffix') || '';
    var start = null, dur = 1400;
    function fmt(n) { var s = String(Math.round(n)); while (s.length < pad) s = '0' + s; return s + suffix; }
    if (reduce) { el.textContent = fmt(target); return; }
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function show(el, delay) {
    if (delay) el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-in');
    var nums = el.hasAttribute('data-fi-count') ? [el] : el.querySelectorAll('[data-fi-count]');
    for (var i = 0; i < nums.length; i++) count(nums[i]);
  }

  function run() {
    tag();
    var els = document.querySelectorAll('[data-fi-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) show(els[i], 0);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target, Math.min(n, 8) * 70);
        n++;
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  root.classList.add('fi-motion-ready');
})();

/* ---------- easter eggs ----------
   1. Konami code (up up down down left right left right b a): the whole site fades to grey.
   2. Type "uniform" anywhere outside a form field.
   3. Double click FADE INDEX on the home page: the letters run down the index.
   4. Open the browser console.
   5. Any missing page is FI-404. */
(function () {
  var root = document.documentElement;
  var ramp = ['#0F1515','#251E1F','#383838','#434549','#646461','#716D6C','#827971','#A8ACAF','#BDB5AB','#DBD8D1'];

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'fi-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-in'); }); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 500); }, 4200);
  }

  function typing(e) {
    var el = e.target; var tag = el && el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (el && el.isContentEditable);
  }

  var code = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  var k = 0, buf = '';
  document.addEventListener('keydown', function (e) {
    if (typing(e)) return;
    var key = e.key && e.key.length === 1 ? e.key.toLowerCase() : e.key;
    k = key === code[k] ? k + 1 : (key === code[0] ? 1 : 0);
    if (k === code.length) {
      k = 0;
      var on = root.classList.toggle('fi-faded');
      toast(on ? 'FI-00 unlocked. Everything goes grey eventually.' : 'Colour back on. For now.');
    }
    if (key && key.length === 1) {
      buf = (buf + key).slice(-7);
      if (buf === 'uniform') { buf = ''; toast('Standard issue confirmed. Welcome in.'); }
    }
  });

  function hero() {
    var w = document.querySelector('.fi-hero-word');
    if (!w || w.getAttribute('data-fi-egg')) return;
    w.setAttribute('data-fi-egg', '1');
    w.addEventListener('dblclick', function () {
      if (!w.querySelector('.fi-l')) {
        var nodes = Array.prototype.slice.call(w.childNodes);
        nodes.forEach(function (n) {
          if (n.nodeType !== 3) return;
          var frag = document.createDocumentFragment();
          n.textContent.split('').forEach(function (ch) {
            var s = document.createElement('span'); s.className = 'fi-l'; s.textContent = ch; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        });
      }
      var letters = w.querySelectorAll('.fi-l');
      var on = !w.classList.contains('fi-shaded');
      w.classList.toggle('fi-shaded', on);
      for (var i = 0; i < letters.length; i++) {
        var c = ramp[Math.min(ramp.length - 1, Math.round(i * (ramp.length - 1) / Math.max(1, letters.length - 1)))];
        letters[i].style.transitionDelay = (i * 90) + 'ms';
        letters[i].style.color = on ? c : '';
      }
      if (on) toast('Pitch to Bone in nine letters.');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hero); else hero();
  document.addEventListener('shopify:section:load', hero);

  try {
    console.log('%cFADE INDEX', 'font:900 28px "Archivo Black","Arial Black",sans-serif;color:#18181A;letter-spacing:-1px');
    console.log('%cStandard issue. 16 shades, one stitch, no print.\nIf you are reading this you are one of us. Try the old cheat code.\nhello@fadeindex.co.uk',
      'font:12px "IBM Plex Mono",monospace;color:#6B6B68');
  } catch (e) {}
})();
